module.exports = __webpack_public_path__ + "static/media/FOTO2.62f8598e.jpg";